import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Users, Calendar, HeartHandshake, Lock } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
const LandingPage = () => {
  return <div className="min-h-screen flex flex-col" data-id="element-546">
      <Header data-id="element-547" />
      {/* Hero Section */}
      <section className="relative py-20 px-4 md:px-8 flex flex-col items-center justify-center text-center bg-gradient-to-r from-emerald-800 to-teal-800 text-white" data-id="element-548">
        <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1577717903315-1691ae25ab3f?q=80&w=2940')] bg-cover bg-center" data-id="element-549"></div>
        <div className="relative z-10 max-w-4xl mx-auto" data-id="element-550">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-551">
            <span className="text-amber-300" data-id="element-552">Emirati</span> Marriage App
          </h1>
          <p className="text-xl md:text-2xl mb-8" data-id="element-553">
            A respectful path to marriage that honors our traditions while
            embracing modern connections
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-554">
            <Link to="/profile-setup" className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-8 rounded-full transition duration-300 shadow-lg" data-id="element-555">
              Create Profile
            </Link>
            <a href="#learn-more" className="bg-transparent hover:bg-white/10 text-white border-2 border-white font-bold py-3 px-8 rounded-full transition duration-300" data-id="element-556">
              Learn More
            </a>
          </div>
        </div>
      </section>
      {/* Features Section */}
      <section id="learn-more" className="py-16 px-4 md:px-8 bg-white" data-id="element-557">
        <div className="max-w-6xl mx-auto" data-id="element-558">
          <h2 className="text-3xl font-bold text-center mb-12 text-emerald-900" data-id="element-559">
            How It Works
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-560">
            {/* Feature 1 */}
            <div className="bg-amber-50 p-6 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-561">
              <div className="bg-emerald-100 p-3 rounded-full mb-4" data-id="element-562">
                <ShieldCheck className="w-8 h-8 text-emerald-700" data-id="element-563" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-emerald-900" data-id="element-564">
                Verified Emirati Users
              </h3>
              <p className="text-gray-700" data-id="element-565">
                UAE Pass integration ensures all users are verified Emiratis,
                creating a trusted community.
              </p>
            </div>
            {/* Feature 2 */}
            <div className="bg-amber-50 p-6 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-566">
              <div className="bg-emerald-100 p-3 rounded-full mb-4" data-id="element-567">
                <Calendar className="w-8 h-8 text-emerald-700" data-id="element-568" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-emerald-900" data-id="element-569">
                Friday Matches
              </h3>
              <p className="text-gray-700" data-id="element-570">
                Every Friday, receive one quality match based on your
                preferences, with time to reflect before deciding.
              </p>
            </div>
            {/* Feature 3 */}
            <div className="bg-amber-50 p-6 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-571">
              <div className="bg-emerald-100 p-3 rounded-full mb-4" data-id="element-572">
                <Users className="w-8 h-8 text-emerald-700" data-id="element-573" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-emerald-900" data-id="element-574">
                Family Inclusion
              </h3>
              <p className="text-gray-700" data-id="element-575">
                Optional Guardian Mode allows family members to be part of your
                journey when you're ready.
              </p>
            </div>
            {/* Feature 4 */}
            <div className="bg-amber-50 p-6 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-576">
              <div className="bg-emerald-100 p-3 rounded-full mb-4" data-id="element-577">
                <Lock className="w-8 h-8 text-emerald-700" data-id="element-578" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-emerald-900" data-id="element-579">
                Privacy Control
              </h3>
              <p className="text-gray-700" data-id="element-580">
                Choose your level of anonymity with optional profile photos and
                controlled information sharing.
              </p>
            </div>
            {/* Feature 5 */}
            <div className="bg-amber-50 p-6 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-581">
              <div className="bg-emerald-100 p-3 rounded-full mb-4" data-id="element-582">
                <HeartHandshake className="w-8 h-8 text-emerald-700" data-id="element-583" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-emerald-900" data-id="element-584">
                Khitbah Process
              </h3>
              <p className="text-gray-700" data-id="element-585">
                When you're ready, initiate a formal Khitbah request to begin
                the traditional engagement process.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Process Section */}
      <section className="py-16 px-4 md:px-8 bg-emerald-50" data-id="element-586">
        <div className="max-w-6xl mx-auto" data-id="element-587">
          <h2 className="text-3xl font-bold text-center mb-12 text-emerald-900" data-id="element-588">
            The Marriage Journey
          </h2>
          <div className="relative" data-id="element-589">
            {/* Timeline Line */}
            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-emerald-200" data-id="element-590"></div>
            {/* Step 1 */}
            <div className="md:flex mb-12 relative" data-id="element-591">
              <div className="md:w-1/2 md:pr-12 md:text-right mb-6 md:mb-0" data-id="element-592">
                <h3 className="text-xl font-semibold mb-2 text-emerald-900" data-id="element-593">
                  Create Your Profile
                </h3>
                <p className="text-gray-700" data-id="element-594">
                  Sign up with UAE Pass for verification, then complete your
                  profile with your preferences, education, and values.
                </p>
              </div>
              <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 bg-white border-4 border-emerald-500 rounded-full h-6 w-6 z-10" data-id="element-595"></div>
              <div className="md:w-1/2 md:pl-12" data-id="element-596"></div>
            </div>
            {/* Step 2 */}
            <div className="md:flex mb-12 relative" data-id="element-597">
              <div className="md:w-1/2 md:pr-12" data-id="element-598"></div>
              <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 bg-white border-4 border-emerald-500 rounded-full h-6 w-6 z-10" data-id="element-599"></div>
              <div className="md:w-1/2 md:pl-12 mb-6 md:mb-0" data-id="element-600">
                <h3 className="text-xl font-semibold mb-2 text-emerald-900" data-id="element-601">
                  Friday Match Day
                </h3>
                <p className="text-gray-700" data-id="element-602">
                  Every Friday, receive one compatible match. You'll have the
                  day to chat and get to know each other.
                </p>
              </div>
            </div>
            {/* Step 3 */}
            <div className="md:flex mb-12 relative" data-id="element-603">
              <div className="md:w-1/2 md:pr-12 md:text-right mb-6 md:mb-0" data-id="element-604">
                <h3 className="text-xl font-semibold mb-2 text-emerald-900" data-id="element-605">
                  Reflection Period
                </h3>
                <p className="text-gray-700" data-id="element-606">
                  Saturday through Thursday is your time to reflect on the
                  match. No messaging during this period.
                </p>
              </div>
              <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 bg-white border-4 border-emerald-500 rounded-full h-6 w-6 z-10" data-id="element-607"></div>
              <div className="md:w-1/2 md:pl-12" data-id="element-608"></div>
            </div>
            {/* Step 4 */}
            <div className="md:flex mb-12 relative" data-id="element-609">
              <div className="md:w-1/2 md:pr-12" data-id="element-610"></div>
              <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 bg-white border-4 border-emerald-500 rounded-full h-6 w-6 z-10" data-id="element-611"></div>
              <div className="md:w-1/2 md:pl-12 mb-6 md:mb-0" data-id="element-612">
                <h3 className="text-xl font-semibold mb-2 text-emerald-900" data-id="element-613">
                  Khitbah Request
                </h3>
                <p className="text-gray-700" data-id="element-614">
                  If interested, send a Khitbah request. If both parties accept,
                  you'll move to the formal introduction phase.
                </p>
              </div>
            </div>
            {/* Step 5 */}
            <div className="md:flex relative" data-id="element-615">
              <div className="md:w-1/2 md:pr-12 md:text-right mb-6 md:mb-0" data-id="element-616">
                <h3 className="text-xl font-semibold mb-2 text-emerald-900" data-id="element-617">
                  Family Involvement
                </h3>
                <p className="text-gray-700" data-id="element-618">
                  Invite family members to join the conversation when you're
                  ready to take the next step.
                </p>
              </div>
              <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 bg-white border-4 border-emerald-500 rounded-full h-6 w-6 z-10" data-id="element-619"></div>
              <div className="md:w-1/2 md:pl-12" data-id="element-620"></div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section - Placeholder for future */}
      <section className="py-16 px-4 md:px-8 bg-white" data-id="element-621">
        <div className="max-w-6xl mx-auto text-center" data-id="element-622">
          <h2 className="text-3xl font-bold mb-12 text-emerald-900" data-id="element-623">
            Our Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-624">
            <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-625">
              <h3 className="text-xl font-semibold mb-3 text-emerald-900" data-id="element-626">
                Privacy
              </h3>
              <p className="text-gray-700" data-id="element-627">
                Your personal information is protected with government-grade
                security and encryption.
              </p>
            </div>
            <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-628">
              <h3 className="text-xl font-semibold mb-3 text-emerald-900" data-id="element-629">
                Respect
              </h3>
              <p className="text-gray-700" data-id="element-630">
                Our platform is built on Islamic values and Emirati traditions,
                ensuring respectful interactions.
              </p>
            </div>
            <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-631">
              <h3 className="text-xl font-semibold mb-3 text-emerald-900" data-id="element-632">
                Community
              </h3>
              <p className="text-gray-700" data-id="element-633">
                Created by Emiratis for Emiratis, with guidance from community
                elders and scholars.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 px-4 md:px-8 bg-gradient-to-r from-emerald-800 to-teal-800 text-white" data-id="element-634">
        <div className="max-w-4xl mx-auto text-center" data-id="element-635">
          <h2 className="text-3xl font-bold mb-6" data-id="element-636">
            Ready to Begin Your Journey?
          </h2>
          <p className="text-xl mb-8" data-id="element-637">
            Join our community of Emiratis seeking meaningful marriage
            connections.
          </p>
          <Link to="/profile-setup" className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-8 rounded-full transition duration-300 shadow-lg inline-block" data-id="element-638">
            Create Your Profile
          </Link>
        </div>
      </section>
      <Footer data-id="element-639" />
    </div>;
};
export default LandingPage;